import React from 'react'

export const Pattern = ({ pattern, onClick }) => {
    return (
        <div className="pattern-item" onClick={onClick}>
                {/* <img
                    src={`${MIX_URL}/front-end/img/loading.gif`}
                    alt="Loading"
                    className="h-200 w-auto loading"
                /> */}

                        <img
                            src={`${MIX_AWS_URL}/${pattern.thumb_image}`}
                            className="w-80 h-80"
                        />
                <h4>{pattern.name}</h4>
                <span>{pattern.family}</span>
        </div>
    )
}